import { Link, useLocation } from "react-router-dom";
import {
  APP_NAME,
  APP_TAGLINE,
  EXPERIENCES,
} from "../config/earthDayExperience";
import "./console-header.scss";

const navLinks = [
  EXPERIENCES.study,
  EXPERIENCES.course,
  EXPERIENCES.facilitator,
];

export default function ConsoleHeader() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className="console-global-header">
      <div className="cgh-left">
        <Link to="/" className="cgh-logo">
          <span className="cgh-logo-mark">Earth Day</span>
          <span className="cgh-logo-name">{APP_NAME}</span>
        </Link>
        <div className="cgh-meta">
          <span className="cgh-kicker">Powered by Gemini</span>
          <p>{APP_TAGLINE}</p>
        </div>
      </div>

      <div className="cgh-right">
        <nav className="cgh-nav" aria-label="Primary">
          {navLinks.map((link) => {
            const isActive =
              currentPath === link.route ||
              (link.route !== "/" && currentPath.startsWith(link.route));

            return (
              <Link
                key={link.route}
                to={link.route}
                className={`cgh-link ${isActive ? "active" : ""}`}
              >
                <span className="cgh-link-label">{link.navLabel}</span>
                <span className="cgh-link-text">{link.title}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}
